import { render, staticRenderFns } from "./EditBlog.vue?vue&type=template&id=522342c8&"
import script from "./EditBlog.vue?vue&type=script&lang=js&"
export * from "./EditBlog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports